import { z } from "zod"

// The only place `import.meta.env` is read. Everything else imports the parsed
// `env` object, so a missing or malformed variable fails here at startup rather
// than as a confusing runtime bug.
//
// Note what is NOT required: VITE_API_BASE_URL. That variable is the *upstream*
// the dev proxy and nginx forward to (see vite.config.ts / nginx.conf.template);
// the browser never uses it, and the production image is built without a .env
// file — requiring it here would break the container.
const envSchema = z.object({
  VITE_APP_TITLE: z.string().min(1).default("Parental Control Admin"),

  /**
   * Same-origin path the browser calls. The API sends no CORS headers, so
   * requests must go through the proxy — pointing this at the API's own origin
   * only works once the backend allows the panel's origin.
   */
  VITE_API_PREFIX: z.string().min(1).default("/api"),

  VITE_API_TIMEOUT: z.coerce.number().int().positive().default(30_000),

  MODE: z.string().default("development"),
  DEV: z.boolean().default(false),
  PROD: z.boolean().default(false),
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {
  if (import.meta.env.DEV)
    console.error("Env validation errors:", z.flattenError(parsed.error).fieldErrors)
  throw new Error("Invalid environment configuration. Check the terminal output.")
}

export const env = parsed.data
